import React from 'react'
import TablesModalContainer from './container'

const TablesModal = ({open, onClose, onSubmit, initialData, loading}) => {
  return (
    <TablesModalContainer
        open={open} 
        onClose={onClose}
        onSubmit={onSubmit}
        initialData={initialData}
        loading={loading}
    />
  )
}

export default TablesModal
